import { computed } from 'vue';

import { useAuthStore } from '@/stores/auth';
import { useLocaleStore } from '@/stores/locales';

export function setupBeamerScript() {
  const configScript = document.createElement('script');
  configScript.text = `
    var beamer_config = {
      product_id: 'RkhynmBU62973',
      lazy: true
    };
  `;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.defer = true;
  script.src = 'https://app.getbeamer.com/js/beamer-embed.js';

  document.head.appendChild(configScript);
  document.head.appendChild(script);

  script.onload = () => {
    setupBeamerConfig();
  };
}

export function setupBeamerConfig() {
  const authStore = useAuthStore();

  const locale = computed(() => useLocaleStore().getCurrentISO);

  const user = computed(() => authStore.getFullUser);
  const companyPlan = computed(() => authStore.getCompany.plan);
  const isManager = computed(() => authStore.hasPermission('manager_r'));

  const role = computed(() => {
    if (isManager.value) {
      return 'manager';
    } else {
      return 'recruiter';
    }
  });
  const competencyFramework = computed(() => {
    if (authStore.hasPermission('competency_framework_group_r')) {
      return 'with_cf';
    } else {
      return 'without_cf';
    }
  });

  const managerAccount = computed(() => {
    if (authStore.hasPermission('manager_a')) {
      return 'with_ma';
    } else {
      return 'without_ma';
    }
  });

  const voice = computed(() => {
    if (authStore.hasPermission('voice')) return 'with_voice';
    return 'without_voice';
  });

  const beamer = window.Beamer;
  beamer.update({
    language: locale.value,
    force_filter: `${role.value};${companyPlan.value};${competencyFramework.value};${managerAccount.value};${voice.value}`,
    user_firstname: user.value.first_name,
    user_lastname: user.value.last_name,
    user_email: user.value.email,
    user_id: user.value.uuid
  });
}
